exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\np[data-v-07bc3db3] {\n  margin-right: 8px;\n}\n.inline p[data-v-07bc3db3] {\n  display: inline-block;\n}\n[type=\"checkbox\"]+span[data-v-07bc3db3]:not(.lever),\n[type=\"radio\"]+span[data-v-07bc3db3]:not(.lever) {\n  padding-left: 24px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #333;\n}\n", ""]);

// exports
